import { Component, OnInit } from '@angular/core';
import { CompanyList } from "../../shared/components/company/company-list/company-list";

@Component({
  selector: 'app-favorites',
  imports: [CompanyList],
  templateUrl: './favorites.html',
  styleUrl: './favorites.scss'
})
export class Favorites {}